import React from "react";
import { Button, Modal, Select, Spin } from "antd";

import { TariffContent } from "../../../components/tariffsContent";

import "./add_tariff.css";
import {
  getNumberCurrying,
  performersTitles,
  workspaceTitles
} from "../../../../../common/utils/numbersCurrying";

const { Option } = Select;

class AddTariffForm extends React.Component {
  state = {
    tariffs: null,
    Fee: null,
    tariffsPeriods: null,
    modal: {
      visible: false,
      title: ""
    }
  };
  static derivedStateFromProps(props, state) {
    const { tariffsPeriods } = props;
    if (props) {
      if (tariffsPeriods) {
        state = { tariffsPeriods: tariffsPeriods };
      }
    }
    return state;
  }

  componentDidMount() {}

  priceWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  renderPeriodsAndPrice = tariff => {
    const { tariffsPeriods, defaultPrices } = this.props;
    let content = null;
    if (tariffsPeriods !== null) {
      tariffsPeriods.map(period => {
        Object.keys(period).map(item => {
          if (parseInt(item) === tariff.tariffTypeId) {
            content = (
              <React.Fragment>
                <div className="fee_period">
                  <Select
                    getPopupContainer={trigger => trigger.parentNode}
                    defaultValue={period[item].tariffFeePeriod}
                    onSelect={val =>
                      this.props.handleFeePeriod({
                        tariffFeePeriodId: parseInt(val),
                        tariffTypeId: tariff.tariffTypeId
                      })
                    }
                  >
                    {tariff &&
                      tariff.fee_periods &&
                      tariff.fee_periods.map(period => {
                        return (
                          <Option key={period.tariffFeePeriodId}>
                            {period.tariffFeePeriod}
                          </Option>
                        );
                      })}
                  </Select>
                </div>
                <div className="max_count">
                  {
                    <React.Fragment>
                      {defaultPrices &&
                        defaultPrices.map((price, key) => {
                          if (tariff.tariffTypeId === price.tariffTypeId) {
                            if (
                              price.tariffPrice - period[item].tariffPrice >
                              0
                            ) {
                              return (
                                <span
                                  key={key}
                                  style={{
                                    position: "absolute",
                                    fontSize: 14,
                                    right: 10,
                                    color: "#9b9b9b"
                                  }}
                                >
                                  -{" "}
                                  {this.priceWithSpaces(
                                    price.tariffPrice - period[item].tariffPrice
                                  )}{" "}
                                  руб.
                                </span>
                              );
                            }
                            return null;
                          }
                          return null;
                        })}
                      <span>
                        <span className="num">
                          {this.priceWithSpaces(period[item].tariffPrice)}
                        </span>{" "}
                        руб. / ТС
                      </span>
                    </React.Fragment>
                  }
                  <div className="free_month2">в месяц (с НДС)</div>
                </div>
              </React.Fragment>
            );
          }
          return null;
        });
        return null;
      });
      if (content) {
        return content;
      } else {
        return <Spin />;
      }
    }
  };

  render() {
    const { tariff } = this.props;
    // const { getFieldDecorator } = form;
    return (
      <div key={tariff.tariffTypeKey} className="tariff_block">
        <div className={`tariff_header ${tariff.tariffTypeKey}`}>
          {/*<Form.Item>{getFieldDecorator('tariffTypeId')(*/}
          <div className="tariff_title">{tariff.tariffType}</div>
          {/*)}</Form.Item>*/}
        </div>
        <div className="tariff_body">
          <div className={`${tariff.tariffTypeKey} free_month`}>
            60 дней бесплатно!
          </div>
          {this.renderPeriodsAndPrice(tariff)}
          <div className="max_count2">
            {tariff.tariffTypeKey === "maximum" ? "более " : "до "}{" "}
            <span className="num">{tariff.maxVehicleNum}</span> ТС
          </div>
          <div className="max_count2">
            до <span className="num">{tariff.maxDriverNum}</span> водителей
          </div>
          <div className="max_count2">
            <span className="num">{tariff.maxWorkplaceNum}</span>{" "}
            {getNumberCurrying(tariff.maxWorkplaceNum, workspaceTitles)}
          </div>
          <div className="max_count2">
            <span className="num">
              {tariff.maxPerformerNum > 0 ? tariff.maxPerformerNum : ""}
            </span>{" "}
            {getNumberCurrying(tariff.maxPerformerNum, performersTitles)}
          </div>
          {tariff.acbpdpGibddSend === 1 ? (
            <div className="gibdd_send">
              <div className="gibdd_send__b1">
                Автоматическое&nbsp;формирование документов перевозки
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="tariff_footer">
          <Button
            onClick={() => {
              this.props.handleTariff(tariff.tariffTypeId);
            }}
            type="primary"
            size="large"
            className="btn"
          >
            Подключить
          </Button>
          <Button
            onClick={() => {
              this.setState({
                modal: {
                  ...this.state.modal,
                  visible: true,
                  title: tariff.tariffType
                }
              });
            }}
            type="link"
          >
            Подробнее
          </Button>
        </div>
        <Modal
          visible={this.state.modal.visible}
          title={`Тариф «${this.state.modal.title}»`}
          footer={[
            <Button
              type="primary"
              onClick={() => {
                this.setState({
                  modal: {
                    ...this.state.modal,
                    visible: false
                  }
                });
              }}
            >
              Закрыть
            </Button>
          ]}
          closable={false}
        >
          <TariffContent title={this.state.modal.title} />
        </Modal>
      </div>
    );
  }
}

export default AddTariffForm;
